import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { deserify } from '@geneo2-web/shared-ui';
import { useAppSelector } from '../../reduxStore/reduxHooks';
import {
  FA_ACTIVE_ASSESSMENT,
  FA_COMPLETED,
  FA_START_COVER,
  FA_SUBMITTED,
  HOME,
  HOMEWORK_ACTIVE,
  HOMEWORK_COMPLETED,
  HOMEWORK_START_COVER,
  HOMEWORK_STUDENT_DASHBOARD,
  HOMEWORK_SUBMITTED,
  HOMEWORK_VIEW_RECOMMENDATION,
  PERFORMANCE_STUDENT_CHAPTERWISE,
  PERFORMANCE_STUDENT_DASHBOARD,
  RESOURCE_VIEW,
  LEARN_DASHBOARD,
  LEARN_TOPIC_SELECTION,
  LESSON_VIEW,
  OFFLINE_LEARN_DASHBOARD,
  OFFLINE_LEARN_TOPIC_SELECTION,
  OFFLINE_LESSON_VIEW,
  OFFLINE_RESOURCE_VIEW,
  OFFLINE_TOPIC_LESSON,
  TOPIC_LESSON,
} from '../RoutesNomenclature';

const BLOCKED_ROUTE_PREFIXES = {
  learn: [
    HOMEWORK_STUDENT_DASHBOARD,
    HOMEWORK_ACTIVE,
    HOMEWORK_COMPLETED,
    HOMEWORK_SUBMITTED,
    HOMEWORK_START_COVER,
    HOMEWORK_VIEW_RECOMMENDATION,
    FA_START_COVER,
    FA_ACTIVE_ASSESSMENT,
    FA_SUBMITTED,
    FA_COMPLETED,
    // PERFORMANCE_STUDENT_DASHBOARD,
    // PERFORMANCE_STUDENT_CHAPTERWISE,
  ],
  assess: [
    LEARN_DASHBOARD,
    LEARN_TOPIC_SELECTION,
    TOPIC_LESSON,
    LESSON_VIEW,
    RESOURCE_VIEW,
    OFFLINE_LEARN_DASHBOARD,
    OFFLINE_LEARN_TOPIC_SELECTION,
    OFFLINE_TOPIC_LESSON,
    OFFLINE_LESSON_VIEW,
    OFFLINE_RESOURCE_VIEW,
  ],
} as const;

const SessionModeRouteGuard = () => {
  const { pathname } = useLocation();
  const { session_mode } = deserify(useAppSelector((state) => state.auth));

  if (!session_mode || pathname === HOME) {
    return <Outlet />;
  }

  const blockedPrefixes = BLOCKED_ROUTE_PREFIXES[session_mode];
  const isBlockedRoute = blockedPrefixes.some((blockedPath) =>
    pathname.startsWith(blockedPath)
  );

  if (isBlockedRoute) {
    return <Navigate to={HOME} replace />;
  }

  return <Outlet />;
};

export default SessionModeRouteGuard;
